<mat-card>
    <mat-card-header>
        <mat-card-title>Logg inn</mat-card-title>
        <mat-card-subtitle>Velg elektronisk ID</mat-card-subtitle>
    </mat-card-header>

    <a class="provider-link" (click)="login('nbid')">
        <img class="provider-logo" src="../../../assets/images/idporten.svg" alt="ID-porten logo" />
        <div>
            <p class="label">ID-porten</p>
            <p class="text">Logg inn med ID-porten</p>
        </div>
    </a>

    <a class="provider-link" (click)="login('sbid')">
        <img class="provider-logo" src="../../../assets/images/logo-bank-id.svg" alt="Svensk BankID logo" />
        <div>
            <p class="label">Svensk BankID</p>
            <p class="text">Logg inn med svensk BankID</p>
        </div>
    </a>

    <a class="provider-link" (click)="login('mitid')">
        <img class="provider-logo" src="../../../assets/images/mitid.svg" alt="MitID logo" />
        <div>
            <p class="label">MitID</p>
            <p class="text">Logg inn med dansk MitID</p>
        </div>
    </a>

</mat-card>